import React from 'react'
import LegalLayout from '../../components/LegalLayout'

/** 마케팅 정보 수신 동의(선택). URL: /marketing-consent */
const MarketingConsentPage: React.FC = () => {
  return (
    <LegalLayout>
      <h1>마케팅 정보 수신 동의</h1>

      <p>
        TASTEE는 이용자에게 유용한 서비스 소식과 혜택 정보를 제공하기 위해 마케팅
        정보를 발송할 수 있습니다.
      </p>

      <h2>수집·이용 항목</h2>
      <ul>
        <li>휴대전화번호, 앱 푸시 토큰</li>
      </ul>

      <h2>수집·이용 목적</h2>
      <ul>
        <li>신규 기능, 이벤트, 프로모션 등 광고성 정보 안내</li>
      </ul>

      <h2>발송 방법</h2>
      <ul>
        <li>앱 푸시 알림, 문자메시지(SMS)</li>
      </ul>

      <h2>보유·이용 기간</h2>
      <ul>
        <li>동의 철회 또는 회원 탈퇴 시까지</li>
      </ul>

      <h2>동의를 거부할 권리</h2>
      <p>
        본 마케팅 정보 수신 동의는 선택 사항이며, 동의하지 않아도 회원 가입 및
        서비스 이용에는 제한이 없습니다. 동의 후에도 언제든지 앱 설정을 통해 수신을
        거부(철회)할 수 있습니다.
      </p>

      <p>
        ※ 친구 요청, 태그 등 서비스 운영에 필요한 알림은 수신 동의 여부와 관계없이
        발송됩니다.
      </p>
    </LegalLayout>
  )
}

export default MarketingConsentPage
